import BlogList from "@/components/sections/BlogList";
import Pagination from "@/components/pagination";
import { useState } from "react";
import TabButton from "@/components/actions/TabButton";
import { getBlogListData } from "@/api/blog";
import useRouterPush from "hooks/useRouterPush";
import { generateUrlToQuery } from "@/utils/helpers/queryString";
import { useGetBlogList } from "repo/blog";
import MetaData from "@/components/seo/MetaData";
import { useEffect } from "react";

function Blogs({ blogData }) {
  const [blogList, setBlogList] = useState(blogData?.articles);
  const { updateQueryParams, queryParams } = useRouterPush();
  const [selectedFilter, setSelectedFilter] = useState(
    () => queryParams?.categories || "all"
  );
  const [paginationData, setPaginationData] = useState(blogData.meta);

  useEffect(() => {
    setSelectedFilter(queryParams.categories || "all");
  }, [queryParams]);

  useGetBlogList(generateUrlToQuery(queryParams), {
    onSuccess: (data) => {
      setBlogList(data.articles);
      setPaginationData(data.meta);
    },
    enabled: Object.keys(queryParams).length >= 1,
  });

  const handleBlogFilter = (option) => {
    setSelectedFilter(option);
    updateQueryParams({ categories: option, page: 1 });
  };

  return (
    <>
      <MetaData {...blogData.metadata} schema={blogData.schema} />

      <div className="mx-auto pb-[4.875rem] lg:pb-[7.5rem]">
        <div className="bg-[#FCF4F4] w-full ">
          <div className="h-[8.125rem] lg:h-[12.063rem] flex items-center justify-center">
            <h1 className="font-semibold text-heading2 lg:text-display2">
              Amarpet Blog
            </h1>
          </div>

          <div className="px-[1.25rem] lg:px-[7.5rem] flex flex-nowrap overflow-x-auto bg-[#FEFAFA] space-x-[1.688rem] lg:space-x-[4.875rem]">
            {blogData?.categories.map((option) => (
              <TabButton
                key={option.slug}
                btnText={option.name}
                isActive={option.slug === selectedFilter}
                onClick={() => handleBlogFilter(option.slug)}
              />
            ))}
          </div>
        </div>
        <div className="mt-[3.5rem] lg:mt-[5rem] px-[1.25rem] lg:px-[7.5rem] space-y-[3.875rem] lg:space-y-[5.625rem]">
          <BlogList blogData={blogList} />
          {paginationData.last_page > 1 && (
            <Pagination
              total={Math.ceil(paginationData.total / paginationData.per_page)}
              currentPage={paginationData.current_page - 1}
              getPaginateData={(currentIndex) =>
                updateQueryParams({ page: currentIndex + 1 })
              }
            />
          )}
        </div>
      </div>
    </>
  );
}

export const getStaticProps = async () => {
  const resData = await getBlogListData();
  return {
    props: {
      blogData: resData.data,
    },
  };
};

export default Blogs;
